<script setup lang="ts">
import type { NavigationItemsCollectionItem } from '@fondof-ui/types'
import HeaderNavSubItem from '@storefront-satch/components/organisms/navigation/HeaderNavSubItem.vue'

const props = defineProps<{
  submenu?: NavigationItemsCollectionItem[] | null
  label?: string | null
  locale: string
}>()
</script>

<template>
  <div
    class="bg-primary-light inset-x-0 z-10 hidden w-full px-5 max-lg:group-[.parent-active]/parent:flex lg:absolute lg:justify-center lg:px-14 lg:group-hover/parent:flex"
  >
    <ul
      class="max-w-screen-max flex w-full flex-wrap overflow-hidden py-5 lg:justify-end lg:pb-[28px] lg:pt-[40px]"
      :data-parent-label="props.label"
    >
      <HeaderNavSubItem
        v-for="sublink in props.submenu"
        :key="sublink.sys.id"
        :nav-link="sublink"
        :locale="props.locale"
      />
    </ul>
  </div>
</template>

<style scoped>
@media (max-width: 1279.98px) {
  .navigation__item--bags ul {
    padding-top: 0;
  }
}
</style>
